import React from 'react';
import PropTypes from 'prop-types';
import { SimpleHeroPaperEmptyPageTemplate } from './SimpleHeroPaperEmptyPageTemplate';

export { SimpleHeroPaperEmptyPageTemplate };

export const SimpleHeroPaperEmptyPageWithoutRefreshTemplate = ({ resource }) => {
  return <SimpleHeroPaperEmptyPageTemplate resource={resource} refreshAfterwards={false} />;
};

SimpleHeroPaperEmptyPageWithoutRefreshTemplate.propTypes = {
  resource: PropTypes.object.isRequired,
};
